export const BASE_DT_TRY = 'BASE_DT_TRY';
export const BASE_DT_OK = 'BASE_DT_OK';
export const BASE_DT_ERROR = 'BASE_DT_ERROR';